export type SessionDetailsRouteState = {
  activeTabIndex?: number;
};

export function withActiveTabIndex<TRouteState extends object>(
  routeState: TRouteState,
  activeTabIndex: number
): TRouteState & SessionDetailsRouteState;
export function withActiveTabIndex(
  routeState: null | undefined,
  activeTabIndex: number
): SessionDetailsRouteState;
export function withActiveTabIndex<TRouteState extends object>(
  routeState: TRouteState | null | undefined,
  activeTabIndex: number
) {
  return routeState
    ? {
        ...routeState,
        activeTabIndex,
      }
    : {
        activeTabIndex,
      };
}
